import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

export const useScrapVehicles = () => {
  const scrapVehiclesRef = useRef([])
  const { scrapVehicles: scrapVehiclesState, newScrapVehicle } = useSelector(
    state => state.inboundTicket.transportationInformation,
  )

  // Watch scrap vehicle information and push to ref
  useEffect(() => {
    scrapVehiclesRef.current = scrapVehiclesState
  }, [scrapVehiclesState])

  return {
    scrapVehiclesRef,
    newScrapVehicle,
  }
}
